module.exports = __webpack_public_path__ + "d1fe81e9b49835f94ba91e74f79720b3.pdf";